import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MutationFunction } from 'react-apollo';
import { Form as FormikForm, Formik, FormikHelpers } from 'formik';

import {
  CreateManualNotificationComponent,
  GetManualNotificationsDocument,
  ManualNotificationsItemInput,
  QueryGetManualNotificationItemsArgs,
  UserSegment,
} from 'api';
import { useNotify } from 'hooks';
import { createMessage } from 'apollo/reducers';
import { NotificationSchema } from 'features/admin/validations';

import { CREATE_MESSAGE_VALUES } from './constants';
import Form from './Form';

interface IProps {
  segments: UserSegment[];
  queryVariables: QueryGetManualNotificationItemsArgs;
}

const CreateMessage: FC<IProps> = ({ segments, queryVariables }) => {
  const [working, setWorking] = useState(false);
  const { t } = useTranslation();
  const notify = useNotify();

  function handleError() {
    setWorking(false);
    notify.mutationError();
  }

  function handleCompleted() {
    setWorking(false);
    notify.info({ message: t('messages:createManualNotificationMessageSuccess') });
  }

  function handleSubmit(
    mutation: MutationFunction,
    data: ManualNotificationsItemInput,
    actions: FormikHelpers<ManualNotificationsItemInput>,
  ) {
    setWorking(true);
    data.message.url = data.message.url || null;

    return mutation({
      variables: { data },
      update: (cache, result) => {
        createMessage({
          cache,
          result,
          query: GetManualNotificationsDocument,
          variables: queryVariables,
        });
        actions.resetForm();
        actions.setFieldValue('entire_company', true);
        actions.setFieldValue('segment_ids', []);
      },
    });
  }

  return (
    <CreateManualNotificationComponent onError={handleError} onCompleted={handleCompleted}>
      {mutation => (
        <Formik
          onSubmit={(values, actions) => handleSubmit(mutation, values, actions)}
          initialValues={CREATE_MESSAGE_VALUES}
          validationSchema={NotificationSchema}>
          {() => (
            <FormikForm>
              <Form
                titleI18nKey="messages:newCompanyMessage"
                segments={segments}
                working={working}
              />
            </FormikForm>
          )}
        </Formik>
      )}
    </CreateManualNotificationComponent>
  );
};

export default CreateMessage;
